import React from "react";
import { BrowserRouter, Switch, Route, Redirect } from "react-router-dom";
import axios from "axios";
import { api } from "./api";

import AuthContext from "./context/auth-context";

import Navigation from "./components/navBar";
import AuthPage from "./components/auth";
import UrlPage from "./components/url";

import "bootstrap/dist/css/bootstrap.min.css";
import "./App.scss";

class App extends React.Component {
	state = {
		isLoading: false,
		token: localStorage.getItem("token"),
		user: null,
		msg: null,
		status: false,
	};

	loadUser = async () => {
		this.setState({ isLoading: true });
		try {
			const res = await axios.get(`${api}/login/user`, {
				headers: {
					"Content-Type": "application/json",
					"x-auth-token": `${this.state.token}`,
				},
			});
			this.setState({ isLoading: false, user: res.data });
		} catch (err) {
			if (err.response) {
				localStorage.removeItem("token");
				this.setState({ isLoading: false, token: null });
			}
		}
	};

	componentDidMount() {
		this.loadUser();
	}

	login = (token, user, msg) => {
		localStorage.setItem("token", token);
		this.setState({
			token: token,
			user: user,
		});
		this.createMessage(true, msg);
	};

	logout = () => {
		localStorage.removeItem("token");
		this.setState({
			token: null,
			user: null,
		});

		this.createMessage(true, "Logout Successful");
	};

	errorLogout = (msg) => {
		localStorage.removeItem("token");
		this.setState({
			token: null,
			user: null,
		});
		this.createMessage(false, msg);
	};

	createMessage = async (status, msg) => {
		this.setState({
			status: status,
			msg: msg,
		});

		await new Promise(async (resolve) => await this.deleteMsg(resolve));
	};

	deleteMsg = (resolve) => {
		setTimeout(async () => {
			await this.setState({ status: true, msg: null });
			resolve();
		}, 6000);
	};

	render() {
		return (
			<BrowserRouter>
				<AuthContext.Provider
					value={{
						token: this.state.token,
						user: this.state.user,
						login: this.login,
						logout: this.logout,
						errorLogout: this.errorLogout,
						status: this.state.status,
						msg: this.state.msg,
						createMessage: this.createMessage,
					}}
				>
					<Navigation loading={this.state.loading} />
					<main className="main-content">
						<Switch>
							{!this.state.token && <Redirect from="/" to="/auth" exact />}
							{this.state.token && <Redirect from="/" to="/urls" exact />}

							{this.state.token && <Redirect from="/auth" to="/urls" exact />}
							{!this.state.token && <Redirect from="/urls" to="/auth" exact />}

							{!this.state.token && (
								<Route path="/auth" exact component={AuthPage} />
							)}
							{this.state.token && (
								<Route path="/urls" exact component={UrlPage} />
							)}
						</Switch>
					</main>
					<footer
						style={{
							marginTop: "3rem",
							textAlign: "center",
							fontSize: "1.6rem",
							background: "#1c3d3d",
							color: "white",
						}}
					>
						Created by{" "}
						<a
							href="https://tekhin3.netlify.app"
							target="_blank"
							className="footerLink"
							rel="noopener noreferrer"
						>
							<i>tekhin</i>
						</a>
						, &#169; 2020
					</footer>
				</AuthContext.Provider>
			</BrowserRouter>
		);
	}
}

export default App;
